"use client";
import { Stack } from "@chakra-ui/react";
import CardsList from "@/components/cardsList";
import { scrollToElement } from "@/utils/scrollToElement";
import { Button } from "@/elements";
import { LBGhoverEffect } from "styles/hoverPresets";
import { HOSTED_OPEN_TEXT_NOM_FEATURES } from "./constants";

const Features = () => {
  return (
    <Stack gap={12}>
      <CardsList
        columns={{ base: 1, sm: 2, md: 4 }}
        title={HOSTED_OPEN_TEXT_NOM_FEATURES.title}
        list={HOSTED_OPEN_TEXT_NOM_FEATURES.list}
        spacing={{ base: 8, md: 12 }}
        hoverEffect
        hover={LBGhoverEffect}
      />
      <Button
        variant={"ideal"}
        onClick={() => scrollToElement("contact-us", 120)}
        alignSelf={"center"}
        p={6}
      >
        Get Started with OneMind&apos;s Hosted NOM
      </Button>
    </Stack>
  );
};

export default Features;
